<template>
  <div class="grid my-5">
    <div>
        <Toast />

        <div class="bg-white p-4 rounded-md">
            <Steps :model="items" :readonly="false" />
        </div>

        <router-view v-slot="{Component}" class="mt-4" :formData="formObject" @prevPage="prevPage($event)" @nextPage="nextPage($event)" @complete="complete">
            <keep-alive>
                <component :is="Component" />
            </keep-alive>
        </router-view>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import Steps from 'primevue/steps'
import storeTutela from '@/apps/pharmasan/juridica/procesosJuridicos/store/tutela.store'
import storeLocalizacion from '@/apps/pharmasan/juridica/procesosJuridicos/store/localizacion.store'
export default {
  name: 'ProcesosJuridicosTutelas',
  components: { Steps },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const toast = useToast()
    const items = ref([
      {
        label: 'Buscar accionante',
        to: 'buscar-accionante'
      },
      {
        label: 'Crear accionante',
        to: 'datos-accionante'
      },
      {
        label: 'Información del juzgado',
        to: 'buscar-juzgado'
      },
      {
        label: 'Detalles de la tutela',
        to: 'detalle-tutela'
      }
    ])
    const formObject = ref({})
    const nextPage = (event) => {
      console.log('evento--- >', event)
      for (const field in event.formData) {
          formObject.value[field] = event.formData[field]
      }

      router.push(items.value[event.pageIndex + 1].to)
    }
    const prevPage = (event) => {
        router.push(items.value[event.pageIndex - 1].to)
    }
    const complete = () => {
        toast.add({ severity: 'success', summary: 'Order submitted', detail: 'Dear, ' + formObject.value.firstname + ' ' + formObject.value.lastname + ' your order completed.' })
    }

    /** computed **/
    // const tutela = computed(() => storeTutela.getters._tutela)

    onMounted(() => {
      storeTutela.dispatch('find', route.params.id)
      storeLocalizacion.dispatch('getDeparatamentos')
    })

    return {
      items,
      formObject,
      nextPage,
      prevPage,
      complete
    }
  }
}
</script>
<style scoped>
</style>
